import React from 'react';

import Select from 'react-select';

import { inlineStyles, getOptions } from 'helpers/react_select_helpers';
import { getSelectValue, parseSelectValue } from './option';
import OptionRow from './option_row';
import { optionPropTypes } from './option_prop_types';

class Enum extends React.Component {
  static propTypes = optionPropTypes;

  static type = 'enum'

  handleChange = (selectOption) => {
    this.props.onChange({
      [this.props.option.id]: parseSelectValue(this.props.option, selectOption)
    });
  }

  renderInputs = () => {
    return (
      <Select
        className="w-100"
        isClearable={false}
        isDisabled={this.props.disabled}
        isMulti={this.props.option.multiselect}
        menuPosition="fixed"
        options={getOptions(this.props.option.values)}
        styles={inlineStyles}
        value={getSelectValue(this.props.option, this.props.value)}
        onChange={this.handleChange}
      />
    );
  }

  renderHiddenValue = () => {
    let value = getSelectValue(this.props.option, this.props.value);
    if (this.props.option.multiselect) {
      value = value.length === 0 ? false : value.map(option => option.label).join(', ');
    } else {
      value = value.label;
    }

    return `Hidden (${value || '<Blank>'})`;
  }

  render() {
    return (
      <OptionRow
        {...this.props}
        inputsClassName="enum"
        renderHiddenValue={this.renderHiddenValue}
        renderInputs={this.renderInputs}
      />
    );
  }
}

export default Enum;
